import { creatorbase } from '@round/api';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';

export const getCampaignLink = (campaign?: creatorbase.Campaign | null) => {
    if (!campaign) {
        return '';
    }

    return `/${CREATORBASE_ROOT_PATH}/projects/${campaign?.project_id}/?expanded=${campaign?.id}#${campaign?.platform}`;
};

const NON_BLOCKING_PAYMENT_STATUSES: ReadonlyArray<creatorbase.CampaignPaymentStatus> = ['CANCELLED', 'FAILED'];

export const isCampaignCostLockedByPayment = (
    paymentStatus: creatorbase.CampaignPaymentStatus | null | undefined
): boolean => !!paymentStatus && !NON_BLOCKING_PAYMENT_STATUSES.includes(paymentStatus);
